module.exports = __webpack_public_path__ + "static/media/icon_signatures.4992719d.png";